module.exports = __webpack_public_path__ + "static/media/WY.807b2e1b.png";